define(['angular', 'app'], function (angular, app) {
    app.filter('parseInt', function() {
        return function(input) {
           return parseInt(input);
        }
    });
});